import React, { ReactElement } from 'react';
import { Copy } from 'containers/selfOnboarding/steps/utils';
import { SelfOnboardingStepProps } from 'containers/selfOnboarding/steps/types';
import { commonClasses } from 'containers/selfOnboarding/steps/common.style';
import { ExclamationTriangleIcon } from 'components/icons';

export function ErrorStep({
  localize,
}: Pick<SelfOnboardingStepProps, 'localize'>): ReactElement {
  return (
    <div className={commonClasses.stepContainer}>
      <div className="odin-p-7.5 sm:odin-col-span-3">
        <div className="odin-p-6 odin-rounded-xl odin-bg-odin-light-red odin-text-center">
          <ExclamationTriangleIcon className="odin-text-3xl odin-text-odin-danger" />
          <h2 className="odin-my-3 odin-text-1.5xl odin-text-gray-900 odin-font-medium">
            {localize(Copy.self_onboarding_error_heading)}
          </h2>
          <div className="odin-text-sm odin-text-gray-600">
            {localize(Copy.self_onboarding_error_text)}
          </div>
        </div>
      </div>
    </div>
  );
}
